import { string, number } from 'prop-types';
import React, { Fragment } from 'react';
import Image from 'components/Image';

const MAX_LOGO_SIZE = 128;

// CLEANUP Capitalize the variant name to normalize it for BEM
function BundleSponsor({ cssHook, imageUrl, messaging, name, maxLogoSize }) {
  // Bail early if neither the name or imageUrl is provided
  if (!name && !imageUrl) {
    return null;
  }

  // We use "Cake" to avoid adblock class/id blacklists
  const baseClass = `${cssHook}__cake`;
  const slug = name ? name.toLowerCase().replace(/\s/gi, '-') : '';
  const nodeClasses = {
    image: name && `${baseClass}-logo--${slug}`,
    messaging: `${baseClass}-messaging`,
    name: `${baseClass}-name`
  };

  return (
    <div className={baseClass}>
      {messaging && (
        <Fragment>
          <span className={nodeClasses.messaging}>{messaging}</span>
          &nbsp;
        </Fragment>
      )}
      {imageUrl ? (
        <span className={nodeClasses.name}>
          <Image
            className={nodeClasses.image}
            url={imageUrl}
            maxSize={{
              width: maxLogoSize || MAX_LOGO_SIZE
            }}
            sourceSizes={[
              {
                layoutWidth: {
                  value: maxLogoSize || MAX_LOGO_SIZE,
                  units: `px`
                }
              }
            ]}
            alt={name && name}
          />
        </span>
      ) : (
        <span
          className={nodeClasses.name}
          dangerouslySetInnerHTML={{ __html: name }}
        />
      )}
      <style jsx>{`
        .${cssHook}__cake, .${nodeClasses.messaging} {
          font-size: 1em;
        }
      `}</style>
    </div>
  );
}

BundleSponsor.propTypes = {
  imageUrl: string,
  messaging: string,
  name: string,
  maxLogoSize: number,
  cssHook: string.isRequired
};

BundleSponsor.defaultProps = {
  imageUrl: undefined,
  messaging: undefined,
  name: undefined,
  maxLogoSize: 128
};

export default BundleSponsor;
